import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api, clearSession, saveSession } from 'src/utils/auth';
import { env } from 'src/env';

export default function WorkerReview() {
  const { coId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  useEffect(() => {
    const opener = window.opener;
    if (!coId) {
      setError('관리자 사용자 목록의 바로가기로 접속해 주세요.');
      return;
    }
    // Production uses the same origin; separate admin ports are allowed only locally.
    const local = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
    const adminOrigins = local
      ? ['http://localhost:9506', 'http://127.0.0.1:9506', 'http://[::1]:9506']
      : [window.location.origin];
    let active = true;
    let started = false;
    const timers: { timer?: number; retry?: number } = {};
    const cleanup = () => {
      window.removeEventListener('message', receive);
      window.clearTimeout(timers.timer);
      window.clearInterval(timers.retry);
    };
    const start = async (session: any) => {
      if (started) return;
      started = true;
      cleanup();
      try {
        if (!['ADM', 'OP'].includes(session?.principal?.role)) throw new Error('사용자 모드 접근 권한이 없습니다.');
        sessionStorage.removeItem('review_user');
        sessionStorage.setItem('review_co_id', coId);
        saveSession(session);
        const { data } = await api.get(`${env.REACT_APP_API_HOST}/api/auth/me`, {
          params: { acct_year: session.principal.login_year },
        });
        if (String(data.status?.code) !== '200' || !data.data?.result?.review) {
          throw new Error(data.status?.message || '근로자 정보를 확인할 수 없습니다.');
        }
        if (!active) return;
        sessionStorage.setItem('review_user', JSON.stringify(data.data.result.review));
        window.opener = null;
        navigate('/main', { replace: true });
      } catch (failure: any) {
        clearSession();
        if (active) setError(failure.response?.data?.status?.message || failure.message || '사용자 모드에 접속하지 못했습니다.');
      }
    };
    const receive = (event: MessageEvent) => {
      if (!opener || event.source !== opener || !adminOrigins.includes(event.origin) ||
          event.data?.type !== 'worker-review-session' || event.data.coId !== coId) return;
      void start(event.data.session);
    };
    // /admin and /user-mode share localStorage in production. Snapshot the
    // administrator session into this tab without waiting for an opener message.
    let sharedSession;
    try {
      const principal = JSON.parse(localStorage.getItem('principal') || 'null');
      const access_token = localStorage.getItem('accessToken');
      const refresh_token = localStorage.getItem('refreshToken');
      if (principal?.type === 'ADMIN' && ['ADM', 'OP'].includes(principal.role) && access_token && refresh_token) {
        sharedSession = { principal, access_token, refresh_token };
      }
    } catch { /* Fall back to the authenticated opener handover. */ }
    if (sharedSession) {
      void start(sharedSession);
      return () => { active = false; cleanup(); };
    }
    if (!opener) {
      setError('관리자 사용자 목록의 바로가기로 접속해 주세요.');
      return;
    }
    window.addEventListener('message', receive);
    timers.timer = window.setTimeout(() => {
      cleanup();
      setError('로그인 전달 시간이 초과되었습니다. 관리자 화면을 새로고침한 뒤 다시 접속해 주세요.');
    }, 15000);
    const ready = () => adminOrigins.forEach(origin => opener.postMessage({ type: 'worker-review-ready' }, origin));
    timers.retry = window.setInterval(ready, 500);
    ready();
    return () => { active = false; cleanup(); };
  }, [coId, navigate]);
  return <p role={error ? 'alert' : 'status'}>{error || '근로자 페이지에 접속하는 중입니다.'}</p>;
}
